import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: ['chartdata', 'options'],
    mounted() {
        this.renderChart(this.chartdata, {

            //maintainAspectRatio: true,

        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/charts/barchart.js